import { isMobile } from "app/assets/javascripts/utils/breakpoints"
import { googletag } from "./shared"
import { getOrCreateStatus, getFullPath } from "./status"
import { ADS_BY_SIZE } from "./sizes"

export const initializeAd = (group, key) => {
  const ad = ADS_BY_SIZE[group][key]
  const status = getOrCreateStatus(group, key)

  if (!document.getElementById(ad.id)) {
    console.log(`No ad container found with id ${ad.id}, skipping initialization`)
    return
  }

  if (status.initialized) {
    return
  }

  const { id, sizes } = ad
  const path = getFullPath(status.activePath)

  googletag.cmd.push(function () {
    if (ad.sizeMapping) {
      const mapping = googletag.sizeMapping()
      ad.sizeMapping.forEach((size) => {
        mapping.addSize(size[0], size[1])
      })

      const builtMapping = mapping.build()

      status.slot = googletag
        .defineSlot(path, sizes, id)
        .setTargeting(id, "true")
        .defineSizeMapping(builtMapping)
        .addService(googletag.pubads())
    } else {
      status.slot = googletag.defineSlot(path, sizes, id).setTargeting(id, "true").addService(googletag.pubads())
    }
  })
  status.initialized = true
  return status
}

const initializeAdGroup = (group) => {
  Object.keys(ADS_BY_SIZE[group]).forEach((key) => {
    const ad = ADS_BY_SIZE[group][key]
    if (ad.skipInitializationOnPageLoad) {
      return
    }

    initializeAd(group, key)
  })
}

export const initializeResponsiveAds = () => {
  if (isMobile()) {
    initializeAdGroup("mobile")
  } else {
    initializeAdGroup("desktop")
  }

  initializeAdGroup("responsive")
}

initializeResponsiveAds()
